import config from '../../config';
import { getAuthHeaders, handleResponse, handleNoContentResponse } from './common';

async function request(path, method = 'GET', body) {
  const response = await fetch(`${config.api.url}/household-budget${path}`, {
    method, headers: getAuthHeaders(), cache: 'no-store',
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  return method === 'DELETE' ? handleNoContentResponse(response) : handleResponse(response);
}
export const householdBudgetApi = {
  access: () => request('/access'),
  get: date => request(date ? `?date=${encodeURIComponent(date)}` : ''),
  allowance: body => request('/allowances', 'POST', body),
  create: body => request('/expenses', 'POST', body),
  edit: body => request(`/expenses/${body.id}`, 'PUT', body),
  delete: entry => request(`/expenses/${entry.id}?version=${entry.version}`, 'DELETE'),
};
